// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"68714226","453":"d29c3f0a","455":"420fa854"}[chunkId] + ".chunk.js";
};